<template>
  <div class="search">
    <Search />
  </div>
</template>

<script>
// @ is an alias to /src
import Search from '@/components/Search.vue'

export default {
  name: 'search',
  components: {
    Search
  }
}
</script>
